import apiHandler from "../core/apiHandler";

const purchasePdfApi = apiHandler('pdf/purchases');
export default purchasePdfApi;
